/* unplugin-vue-components disabled */
import $global from 'stores/global'
import {makeBetaSchema} from '../settings-defs'
import BuilderInputs from 'components/builder/builder-inputs.vue'

export default {
  components: {BuilderInputs},
  provide() {
    return {store: this.beta}
  },
  data() {
    return {
      beta: {...$global.caps},
      schema: makeBetaSchema(),
      saved_at: undefined,
      saving: false,
      valid: true,
    }
  },
  methods: {
    async onUpdate() {
      if (!this.valid) return
      this.saving = true
      try {
        // TODO: put_settings
        await $global.setAdminCaps(this.beta)
        this.saved_at = Date.now()
      }
      catch (err) {
        $utils.toasts.error(err)
      }
      this.saving = false
    },
  },
}
